<template>
    <div class="el-table-container templateBox">
        <div class="p_all1">
            <el-button v-if="hasPermission('converge:setting:connect:add')" type="primary" size="small" @click="addData('add')">新建连接池</el-button>
            <el-button v-if="hasPermission('converge:setting:connect:test')" type="primary" size="small" @click="connect()">联通检测</el-button>
            <el-button v-if="hasPermission('converge:setting:connect:deleteData')" type="danger" size="small" @click="deleteData()">删除</el-button>
            <el-button type="primary" size="small" @click="refreshList(1, 1, 1)">刷新</el-button>
        </div>
        <div class="tips"><el-link class="el-icon-info" type="primary" :underline="false"></el-link>已选择{{dataListSelect.length}}项数据</div>
        <el-table
                :data="dataList"
                v-loading="loading"
                size="small" height="100%"
                class="table" border
                ref="multipleTable"
                :row-key="'id'"
                @sort-change="sortChange"
                @selection-change="selectionChangeHandle"
        >
            <el-table-column :reserve-selection="true" type="selection" width="50"/>
            <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="connectionDatabase" label="数据库" show-overflow-tooltip>
                <template slot-scope="{row}">
                    {{ $dictUtils.getDictLabel("connection_database", row.connectionDatabase, '') }}
                </template>
            </el-table-column>
            <el-table-column prop="connectionTitle" label="标题" show-overflow-tooltip></el-table-column>
            <el-table-column prop="connectionDescription" label="描述" show-overflow-tooltip></el-table-column>
            <el-table-column prop="connectionState" label="状态" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <div>{{ row.connectionState == 0 ? '已连通' : '未连通' }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="connectionCron" label="执行周期" show-overflow-tooltip></el-table-column>
            <el-table-column prop="synchronizationType" label="同步数据值" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <div>{{ row.synchronizationType == 0 ? '全部同步' : '增量同步' }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="detectionDate" label="最近检测时间" show-overflow-tooltip></el-table-column>
            <el-table-column fixed="right" min-width="170px" label="操作">
                <template slot-scope="{row}">
                    <el-button v-if="hasPermission(`converge:setting:connect:see`)" type="text" size="small" @click="addData('see',row)">查看</el-button>
                    <el-button v-if="hasPermission(`converge:setting:connect:connect`)" type="text" size="small" @click="connect('edit',row)">测试连接</el-button>
                    <el-button v-if="hasPermission(`converge:setting:connect:synchr`)" type="text" size="small" @click="synchrData(row)">同步测试</el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <connect-add ref="connectAdd" @refresh="refreshList(1,1)"></connect-add>
    </div>
</template>

<script>
import ConnectAdd from "@/views/modules/converge/setting/connectAdd.vue";

export default {
    name: "connect",
    components: {ConnectAdd},
    data() {
        return {
            searchForm: {
                current: 1,
                size: 20,
            },
            total: 0,

            loading: false,
            dataList: [],
            dataListSelect: [],
        }
    },

    mounted() {
        this.refreshList()
    },

    methods: {
        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect, sort) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            if (sort) {
                this.$refs.multipleTable.clearSort()
            }
            this.loading = true
            this.$axios(this.api.academic.connectionpoolList, this.searchForm).then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },

        // 列表排序
        sortChange(column, type) {
            // sort: column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : '')
            console.log(column)
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },

        //typeName see查看 edit编辑 add新增
        addData(typeName,row){
            this.$refs.connectAdd.init(typeName,row)
        },

        //测试连接
        connect() {
            // this.$refs.searchForm.validate((valid) => {
            //     if (valid) {
            let msaage = this.$message({
                message:'检测中……',
                duration:0,
            });

            setTimeout(()=>{
                msaage.close()
                this.$message.success('检测成功')
            },2000)
            //     }
            // })
        },

        //同步测试
        synchrData(){
            this.$message.success('同步测试成功')
        },

        //删除
        deleteData(row){
            let list = row ? [row] : this.dataListSelect
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let statusTrueList = []
            let ids = list.map(item => {
                if (item.status == 0){
                    statusTrueList.push(item)
                }
                return item.id
            })
            if (statusTrueList.length != 0) {
                this.$message.warning('请先禁用后再删除！')
                return
            }
            this.$confirm(`确认删除所选信息？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.academic.connectionpoolRemoveById, {ids}, 'delete').then(data => {
                    if (data && data.status) {
                        this.$message.success('删除成功')
                        this.refreshList('', 1)
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
    }
}
</script>

<style scoped>
.tips {
    padding: 4px;
    .el-icon-info {
        margin-right: 6px;
    }
}
</style>